<style scoped>
#taybull-pay .list-home-content {
  padding-left: 15px;
}
.taybullpay-router {
  padding-top: 100px;
}
#taybull-pay .drawer {
  background-color: #f3f3f8;
}
#taybull-pay .left-link {
  color: #5a636e;
  padding-bottom: 10px;
  cursor: pointer;
}

#taybull-pay .left-link.active {
  border-right: 5px solid #2196f3;
}

#taybull-pay .left-link .v-list__tile__title {
  font-size: 15px;
}
#taybull-pay .drawer hr {
  margin-right: 75px;
}
#taybull-pay .taybullpay-toolbar .v-toolbar__content {
  padding-left: 320px;
}
#taybull-pay .theme--light.v-toolbar {
  background-color: #fff;
}
.theme--light.application {
  background: #fff;
}
#taybull-pay .transactions {
  width: 100%;
}

#taybull-pay .transactions td {
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 13px;
}
#taybull-pay .transactions .vertical {
  margin-left: 15px;
  font-weight: bold;
}
#taybull-pay .transactions .amount {
  font-weight: bold;
}
#taybull-pay .latest-transactions {
  padding-top: 30px;
}
#taybull-pay .top-cta-row {
  padding-right: 50px;
}

#taybull-pay .top-cta-row .text {
  font-size: 13px;
}
#taybull-pay .top-cta-row .top-cta {
  margin-left: 15px;
  cursor: pointer;
}
</style>
<template>
  <v-app id="taybull-pay">
    <v-navigation-drawer fixed stateless value="true" app class="drawer">
      <v-list two-line v-if="user">
        <v-list-tile avatar>
          <v-avatar color="purple">
            <span class="white--text" v-if="user.fullname">{{
              user.fullname.substring(0, 1)
            }}</span>
          </v-avatar>
          <v-list-tile-content class="list-home-content">
            <v-list-tile-title>{{ user.fullname }}</v-list-tile-title>
            <v-list-tile-sub-title v-if="user.department">{{
              user.department
            }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list v-if="menuList && menuList.length">
        <template v-for="menu in menuList">
          <v-list-tile
            v-if="typeof menu.items === 'undefined'"
            :key="menu.id + menu.title"
            :class="menu.id == activeLink ? menu.class + ' active' : menu.class"
            @click="setRoute(menu)"
          >
            <v-list-tile-action>
              <v-icon :color="menu.color">{{ menu.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
          </v-list-tile>
          <v-list-group
            v-else
            :key="menu.id + menu.title"
            v-model="menu.active"
            :prepend-icon="menu.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ menu.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="subMenu in menu.items"
              :key="menu.id + subMenu.id + subMenu.title"
              @click="setRoute(subMenu)"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ subMenu.title }}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon>{{ subMenu.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <!-- <v-divider :key="menu.id" /> -->
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-content style="padding-left: 280px">
      <v-container fluid class="taybullpay-router-1" style="padding-right: 0px">
        <v-flex xs12 sm12 fill-height v-resize="onResize" ref="layoutContainer">
          <!-- :style="chart.parameters.style ? chart.parameters.style.value : ''" -->
          <div
            class="canvas-inner"
            v-if="chart && chart.layout && chart.layout.grids && display"
          >
            <grid-layout
              v-if="chart.layout.grids"
              :layout.sync="chart.layout.grids"
              :col-num="chart.layout.colNum"
              :row-height="chart.layout.rowHeight"
              :is-draggable="editable"
              :is-resizable="editable"
              :is-mirrored="false"
              :vertical-compact="true"
              :margin="
                chart &&
                chart.parameters.layoutMargin &&
                chart.parameters.layoutMargin.value
                  ? chart.layout.margin
                  : [0, 0]
              "
              :use-css-transforms="false"
              :responsive="false"
              @layout-ready="layoutReadyEvent"
            >
              <grid-item
                :key="index"
                v-for="(item, index) in chart.layout.grids"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :i="item.i"
                @resized="aResized"
              >
                <div
                  :rowHeight="chart.layout.rowHeight"
                  :h="item.h"
                  v-bind:class="[
                    item.id == activeGrid.id ? 'active' : '',
                    'layer-editor',
                  ]"
                  v-on:mouseover="aActivateGrid(item, true)"
                >
                  <Layers v-if="ready" v-bind:grid="item" v-bind:mode="mode" />
                </div>
              </grid-item>
            </grid-layout>
          </div>
        </v-flex>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
// import Layers from '@/components/Layers.vue';
const Layers = () => import("@/components/Layers.vue");
import VueGridLayout from "vue-grid-layout";
// const VueGridLayout = () => import('vue-grid-layout');
import { deleteProject } from "@/models/project";

import { createNamespacedHelpers } from "vuex";

const chartNamespace = createNamespacedHelpers("charts");
const userNamespace = createNamespacedHelpers("users");

export default {
  name: "TaybullLayout",
  props: ["chart", "row", "mode"],
  data: function () {
    return {
      projectId: null,
      dialogDeleteDashboard: false,
      dialogDeleteProject: false,
      output: null,
      d: true,
      menuOpen: false,
      fullscreen: false,
      snackbar: false,
      y: "top",
      x: null,
      timeout: 6000,
      text: "Updated",
      menuList: [],
      activeLink: null,
      ready: false,
    };
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    Layers,
  },
  computed: {
    ...userNamespace.mapState({
      user: (state) => state.user,
    }),
    ...chartNamespace.mapState({
      loadTime: (state) => state.loadTime,
      display: (state) => state.display,
      dialog: (state) => state.dialog,
      showGridMenu: (state) => state.showGridMenu,
      activeGrid: (state) => state.activeGrid,
      activeLayer: (state) => state.activeLayer,
      editable: (state) => state.editable,
      loading: (state) => state.loading,
      progressValue: (state) => state.progressValue,
      theme: (state) => state.theme,
      charts: (state) => state.charts,
    }),
  },
  methods: {
    ...chartNamespace.mapMutations([
      "mSetEditable",
      "mInitializeGrids",
      "mToggleGridMenu",
      "mSetDialog",
      "mAdd",
      "mSetProjectId",
      "mSetTypeGroup",
      "mSet",
      "mSetName",
      "mToggleEditable",
    ]),
    ...chartNamespace.mapActions([
      "aCreateRandomDashboard",
      "aAdd",
      "aInit",
      "aUpdate",
      "aSet",
      "aCleanSet",
      "aCleanSetById",
      "aCleanSetByName",
      "aDelete",
      "aResized",
      "aAddGrid",
      "aActivateGrid",
    ]),
    layoutReadyEvent() {
      // alert('ready');
      this.ready  = true;
    },
    setRoute(menu) {
      try {
        if (menu.route) {
          this.aCleanSetByName(menu.route);
        } else {
          this.aCleanSetByName(menu.title);
        }
      } catch (error) {
        // continue
      }
    },
    updateName: function (event) {
      this.mSetName(event.target.innerText);
    },
    toggle() {
      this.$refs["fullscreen"].toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    notify(text) {
      this.text = text;
      this.snackbar = true;
    },
    async print() {
      // this.output = await this.$html2canvas(el, options);
    },
    async deleteProject() {
      await deleteProject(this.$route.params.projectId);
      this.$router.push({
        name: "projects-home",
      });
    },
    setMenuList() {
      try {
        const menuList = JSON.parse(this.chart.parameters.menuList.value);
        this.menuList = menuList;
      } catch (error) {
        // show
        this.menuList = [];
      }
    },
    onResize() {
      // let width = this.$refs.layoutContainer.clientWidth;
      // console.log("layout resized", this.$refs);
      // console.log("breakpoint", this.chart.getBreakpointUsingWidth(width));
    },
  },
  createRandomDefault() {},
  mounted: function () {
    // console.log("layoutMounted");
    if (this.mode == "view") {
      this.mSetEditable(false);
    }
    this.setMenuList();
    // this.aLoad(chart);

    // this.timeout = setTimeout(function(){
    //             window.dispatchEvent(new Event('resize'));
    //         }, 50);

    // this.mInitializeGrids(this.chart);
  },
  destroyed() {
    // clearTimeout(this.timeout);
  },
  beforeCreate: function () {},
};
</script>